import Button from '@material-ui/core/Button';

export default function DeleteCancel({ onDelete, onCancel, disableButton, content, showCancel=true }) {

    return (
        <>
            {showCancel &&
            <Button onClick={onCancel} variant="contained" style={{ marginLeft: 10, textTransform: 'capitalize' }}>
                Cancel
            </Button> }
            <Button disabled={disableButton} onClick={onDelete} color="secondary" variant="contained" style={{ marginLeft: 10,  textTransform: 'capitalize'}}>
                {content ? content : 'Delete'}
            </Button>
        </>
    )
}